<div class="header-title">
  <div class="flex u-align-items-center u-pa-20">
    <div class="flex flex-align-center">
      <a routerLink="/button" aria-label="back"
        class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" role="button">
        <span class="u-icon icon-chevron-left"></span>
        <span class="u-button-text">Back</span>
      </a>
    </div>
    <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
      <h1 class="font-semibold u-ma-0 flex header-title--name">Footer</h1>
    </div>
  </div>
  <div class="c-header__gradient"></div>
</div>

<maced-footer [links]="linksSpanish" logoImg="./assets/default/images/footer_logo.svg" [logoHyperLink]="meeUrl"
  logoImageAltName="Macmillan Educación" [copyright]="copyrightSpanish" (linkEvent)="onClickLink($event)" [logoWidth] = 150 [logoHeight] = 42>
</maced-footer>

<maced-footer [links]="linksHindi" logoImg="./assets/default/images/footer_logo.svg" [logoHyperLink]="meeUrl"
  logoImageAltName="मैकमिलन एजुकेशन" [copyright]="copyrightHindi" (linkEvent)="onClickLink($event)" [logoWidth] = 150 [logoHeight] = 42>
</maced-footer>

Selected Link:- {{ selectedLink && selectedLink.label }}